import { PayloadAction, createAction, createSlice } from '@reduxjs/toolkit';

import {
  PatientData,
  AppointmentGuideFormValues,
} from 'features/tissInvoicing/types/appointmentGuide';
import { SnackbarProps } from 'features/tissInvoicing/types';
import getSnackbarPayload from 'features/tissInvoicing/utils/getSnackbarPayload';

export type AppointmentGuideFormState = {
  event: {
    id?: string;
    tiss_version: string;
  };
  guide?: AppointmentGuideFormValues;

  form: {
    data: AppointmentGuideFormValues;
  };
  print: {
    pdfURL: string;
    openModal: boolean;
  };
  loading: {
    save: boolean;
    print: boolean;
  };
  snackbar: SnackbarProps;
  patient?: PatientData;
};

export const appointmentGuideFormInitialState: AppointmentGuideFormValues = {
  tiss_version: '',
  ans_register: '',
  guide_number: '',
  main_guide_number: '',
  wallet_number: '',
  wallet_due_date: '',
  newborn: '',
  patient_name: '',
  social_name: '',
  patient_cns: '',
  hired_solicitant_code: '',
  hired_solicitant_name: '',
  hired_cnes_code: '',
  professional_executant_name: '',
  professional_executant_council: '',
  professional_executant_council_number: '',
  professional_executant_council_state: '',
  professional_executant_council_cbo: '',
  accident_indication: null,
  special_coverage: '',
  attendance_regimen: null,
  occupational_health: '',
  request_date: '',
  appointment_type: '',
  tuss_table_code: '',
  procedure_code: '',
  appointment_value: null,
  observation: '',
};

export const initialState: AppointmentGuideFormState = {
  event: {
    tiss_version: '',
  },
  form: {
    data: appointmentGuideFormInitialState,
  },
  print: {
    pdfURL: '',
    openModal: false,
  },
  loading: {
    save: false,
    print: false,
  },
  snackbar: getSnackbarPayload(),
  patient: {} as PatientData,
};

const name = 'appointmentGuide';

const fetchPatientData = createAction<{ patientId: number }>(
  `${name}/fetchPatientData`,
);

const saveGuideData = createAction<{ data: AppointmentGuideFormValues }>(
  `${name}/saveGuideData`,
);

const appointmentGuideSlice = createSlice({
  name,
  initialState,
  reducers: {
    setGuideEvent: (
      state,
      action: PayloadAction<{ id: string; tiss_version: string }>,
    ) => ({
      ...state,
      event: action.payload,
    }),
    setPatientData: (state, action: PayloadAction<PatientData>) => ({
      ...state,
      patient: action.payload,
    }),
    setAppointmentGuide: (
      state,
      action: PayloadAction<AppointmentGuideFormValues>,
    ) => ({
      ...state,
      form: {
        data: action.payload,
      },
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: {
        save: action.payload,
        print: false,
      },
    }),
    setSnackbarContent: (state, action) => ({
      ...state,
      snackbar: {
        message: action.payload.message || null,
        severity: action.payload.severity || 'default',
      },
    }),
  },
});

export default appointmentGuideSlice.reducer;
export const actions = {
  ...appointmentGuideSlice.actions,
  fetchPatientData,
  saveGuideData,
};
